import { render, staticRenderFns } from "./LogsPanel.vue?vue&type=template&id=0c87ae50"
import script from "./LogsPanel.vue?vue&type=script&lang=js"
export * from "./LogsPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports